import {createSelector} from '@ngrx/store';

export const selectFeature = (state) => state.user;
export const accountSelector = createSelector(selectFeature, state => state.account);
export const accountCodesSelector = createSelector(selectFeature, state => state.availableAccounts);
export const dispatcherEntityIdSelector = createSelector(selectFeature, state => state.dispatcherEntityId);
export const userProfileIdSelector = createSelector(selectFeature, state => state?.userProfileId);
export const companyIdSelector = createSelector(selectFeature, state => state?.companyId);
